import { render } from "./InterventionContacts.vue?vue&type=template&id=3576faf0&scoped=true&ts=true"
import script from "./InterventionContacts.vue?vue&type=script&lang=ts"
export * from "./InterventionContacts.vue?vue&type=script&lang=ts"

import "./InterventionContacts.vue?vue&type=style&index=0&id=3576faf0&scoped=true&lang=css"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3576faf0"]])

export default __exports__